<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
  </div>
</template>

<script>
export default {
  name: 'App',
  methods: {
    /* scrollHandler (event) {
      let h = document.documentElement.scrollTop || document.body.scrollTop
      if (h >= 300) {
        document.getElementById('btn_top').style.display = 'block'
      } else {
        document.getElementById('btn_top').style.display = 'none'
      }
    } */
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue